var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimestap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13183_106166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50003 14.4634C10.7546 14.4634 13.3929 11.8251 13.3929 8.57059C13.3929 5.31606 10.7546 2.67773 7.50003 2.67773C4.2455 2.67773 1.60718 5.31606 1.60718 8.57059C1.60718 11.8251 4.2455 14.4634 7.50003 14.4634Z",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89307 0.535156H9.10735",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.535156V2.67801",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89307 6.42773L7.50021 8.57059H10.1788",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8572 2.14258L13.9286 3.21401",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14296 2.14258L1.07153 3.21401",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13183_106166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimestap);
export default __webpack_public_path__ + "static/media/timestap.484ba9f2e807aa409de2dd3d1901459d.svg";
export { ForwardRef as ReactComponent };